module.exports = global.config = {
  API:{
    URL:'https://react.easyquranicarabic.com',
  }

  // other global config variables you wish
};